/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 文件系统语义层分布算法
 */
export enum DistAlgE {
    // 性能模式
    PERFORMANCE_MODE = 0,
    // 容量均衡模式
    CAPACITY_BALANCE_MODE = 1,
    // 目录均衡模式
    DIRECTORY_BALANCE_MODE = 2,
    // 目录轮询模式
    DIRECTORY_SHUFFLE_MODE = 3,
    // 控制器亲和模式
    CONTROLLER_AFFINITY_MODE = 4,
}